import { Box } from '@chakra-ui/react';
import { DownloadIcon } from '@halo/ui-chat-react';
import { MsgPayloadType } from '@halo/chat-sdk';
import type { FileMsg } from '@halo/chat-sdk-react';
import { useRefs } from '@halo/hooks';
import { useMemo } from 'react';

interface MessageImageProps {
  message: FileMsg;
  isMe: boolean;
  onDownload?: (msg: FileMsg) => void;
}

export const MessageDownLoadFile = ({ message, isMe, onDownload }: MessageImageProps) => {
  const refs = useRefs({ onDownload });
  const isFile = useMemo(() => {
    return (
      message?.payload_type === MsgPayloadType.FILE ||
      message?.payload_type === MsgPayloadType.IMAGE
    );
  }, [message?.payload_type]);

  if (!isFile || isMe || !message?.payload?.meta) {
    return null;
  }
  return (
    <Box ml="2">
      <DownloadIcon cursor="pointer" onClick={() => refs.current.onDownload?.(message)} />
    </Box>
  );
};
